module.exports = __webpack_public_path__ + "img/home_3.19f50198.png";